"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block admin-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules,
      "label-width": "160px",
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Current Password",
      prop: "currentPassword"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Current Password",
      "show-password": "",
      name: "currentPassword"
    },
    model: {
      value: _vm.formData.currentPassword,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "currentPassword", $$v);
      },
      expression: "formData.currentPassword"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "New Password",
      prop: "password"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "New Password",
      "show-password": "",
      name: "password"
    },
    model: {
      value: _vm.formData.password,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "password", $$v);
      },
      expression: "formData.password"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Confirm Password",
      prop: "confirmPassword"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Confirm Password",
      "show-password": "",
      name: "confirmPassword"
    },
    model: {
      value: _vm.formData.confirmPassword,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "confirmPassword", $$v);
      },
      expression: "formData.confirmPassword"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "reset"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")])], 1)], 1)], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;